  export function getTimeAgo(dateString: string): string {
    if (!dateString) return '';

    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    } else {
      return `${minutes}m`;
    }
  }
  export interface LocationInfo {
    formattedAddress: string;
    streetAddress: string;
    city: string;
    state: string;
    stateShort: string;
    country: string;
    countryShort: string;
    zipCode: string;
    placeId: string;
    lat: number | null;
    lng: number | null;
  }

  /** Parses the structured JSON stored in a screen's locationInfo. Returns null for
   *  legacy plain-text values (pre-dating this format) or empty/invalid input. */
  export function parseLocationInfo(raw: string): LocationInfo | null {
    if (!raw) return null;
    try {
      const parsed = JSON.parse(raw);
      return parsed && typeof parsed === 'object' ? parsed as LocationInfo : null;
    } catch {
      return null;
    }
  }

  export enum SCREEN_TYPE {
    DISPLAY = 1,
    MEDIA_APP = 2,
    CANVAS = 3,
    BROADCAST = 4,
    PLAYLIST = 5,
    GROUP = 6,
    FOLDER = 7,
    DESIGN = 8,
    SCHEDULER = 9,
    DAILY_LOOP = 10,
  }